import { render, staticRenderFns } from "./ChatSelect.vue?vue&type=template&id=5036a310"
import script from "./ChatSelect.vue?vue&type=script&lang=js"
export * from "./ChatSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports